import React, { Component } from "react";
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import { getFavoritosRef, addFavoritesRef, getMessagesFavoritesServices } from '../../../store/actions/favoritosRef.js';
import { deletePaymentReminder,updatePaymentReminder,getPaymentReminder } from '../../../store/actions/payReminder';
import { executeTaggeo } from "../../../store/actions";
import { getTagServiceId, getMessageFavServices, getListFavsServices } from '../../../store/selectors/paymentsSelectors'
import { ClaroModalCustom, ClaroCardSimple, ClaroModalCardOk, ClaroTextGeneral, ClaroLinkButton, ClaroImageBanner} from "@claropay/shared";
import ModalCustomContainer from "../../molecules/ModalCustomContainer";
import ToolTipTelcelAvisos from '../../organisms/TooltipTelcelAvisos/index.js';
import ClaroButton from "../../atoms/ClaroButton";
import FavoriteElement from '../../atoms/FavoriteElement/';
import ModalCardLoader from "../ModalCardLoader/index.js";
import ClaroInputField from "../../atoms/ClaroInputField";
import InputTitleClaroSocio from '../../molecules/InputTitleClaroSocio';
import ToolTipMiTelcel from '../../organisms/TooltipMiTelcel';
import { getMessage } from "../../organisms/utils.js";
import ModalCardOk from "../ModalCardOk";
import ClaroImage from '../../molecules/ClaroImage';
import { validateUserAgent } from "../../organisms/utils.js";

const ContainerListFavs = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
`
const ButtonClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  background-color: transparent;
`
const LogoServiceFavs = styled.img`
  margin-top: 16px;
  margin-bottom: 24px;
`
const SubtitleServiceFavs = styled.h2`
  font-size: 14px !important;
  font-family: "Amx-Regular";
  color: #848484;
  text-align: left;
  align-self: flex-start;
  margin-bottom: 16px;
  `
  const containerAliasStyles = {
    padding: '0 16px', 
    width:'100%'
};

const containerReferenceStyles = {
    padding: '5px 16px',
    width:'100%'
};

const containerExpirationStyles = {
    padding: '0 16px',
    marginBottom:'16px',
    width:'100%'
};

const p = styled.p`
  color: 'black', fontSize: '12px', textAlign: 'left'`


class CreateFavoriteService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            alias: '',
            modal: false,
            codigo:'',
            disabledButton:true,
        };
    }

    componentDidMount() {
        const {getMessagesFavoritesServices,alias,tagServiceId,executeTaggeo} = this.props
        getMessagesFavoritesServices('PagoServicios');
        if(alias){
            this.setState({ alias: alias })
        }

        executeTaggeo({
            action: "View",
            step: "Formulario de referencia",
            service: tagServiceId,
          });
    }

    componentDidUpdate(prevProps) {
        const {canPaymentReminder,deletePaymentReminderError,executeTaggeo} = this.props
        console.log(canPaymentReminder);
        if(this.state.codigo === '' && this.state.modal && !this.props.isLoadingGetFavServices && !this.props.listFavServices){   
            if(!canPaymentReminder){
                this.handleChangeCodigoModals();
            } else{
                this.handleChangeCodigoModalsReminder(prevProps);
            }      
        }   

        if((deletePaymentReminderError !== undefined) && (deletePaymentReminderError !== prevProps.deletePaymentReminderError)){ // Si hay error 
            console.log("éntra");
            this.setState({cpMessage: "CP0525"});
            this.setState({messageInformation:getMessage(this.props.listMessagesFavServices,"CP0525")})
            // Si no se puede eliminar el servicio guardado
              executeTaggeo({
                action: "View alert",
                step: "Formulario de pago",
                alert_id: "Imposible eliminar servicio",
                service: this.props.tagServiceId,
              });
          }
    }

    handleChangeCodigoModalsReminder = (prevProps) =>{
        const {idReminder,updatePaymentReminderError,hasFavsError,tagServiceId,errorCodeFavs,listMessagesFavServices,updatePaymentReminderSucces} = this.props
        if(!idReminder){
            if(!hasFavsError){
                this.setState({codigo:'CP0528'})
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Servicio Guardado",
                    service: 
                    tagServiceId,
                })
            }else{
                this.setState({codigo:errorCodeFavs})
             this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs )}) 
             executeTaggeo({
                action: "View alert",
                step: "Formulario de pago",
                alert_id: "Imposible consultar guardados",
                service: tagServiceId,
            })
                 
            } 
        }else{
            if(updatePaymentReminderSucces !== prevProps.updatePaymentReminderSucces){
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Guardado editado con éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:'CP0522'})
                this.setState({messageInformation:getMessage(listMessagesFavServices,'CP0522' )})
            }else if(updatePaymentReminderError !== prevProps.updatePaymentReminderError){
                executeTaggeo({
                    action: "View alert",
                    step: "Formulario de pago",
                    alert_id: "Guardado editado sin éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:'CP0521'})
                this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs)})
            }
        }
    }


    handleChangeCodigoModals = () =>{
        const {lidFavorite,hasFavsError,executeTaggeo,tagServiceId,listMessagesFavServices,errorCodeFavs} = this.props
        if(!lidFavorite){
            if(!hasFavsError){
                this.setState({codigo:'CP0528'})
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Servicio Guardado",
                    service: 
                    tagServiceId,
                })
            }else{
                this.setState({codigo:errorCodeFavs})
             this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs )}) 
             executeTaggeo({
                action: "View alert",
                step: "Formulario de pago",
                alert_id: "Imposible consultar guardados",
                service: tagServiceId,
            })
                 
            } 
        }else{
            if(!hasFavsError){
                executeTaggeo({
                    action: "View confirmation",
                    step: "Formulario de pago",
                    confirmation_id: "Guardado editado con éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:'CP0522'})
                this.setState({messageInformation:getMessage(listMessagesFavServices,'CP0522' )})
            }else{
                executeTaggeo({
                    action: "View alert",
                    step: "Formulario de pago",
                    alert_id: "Guardado editado sin éxito",
                    service: tagServiceId,
                })
                this.setState({codigo:errorCodeFavs})
                this.setState({messageInformation:getMessage(listMessagesFavServices,errorCodeFavs)})
            }
        }
    }

    saveFavorites = () => {
      const {lidFavorite,accountService,executeTaggeo,tagServiceId,addFavoritesRef,idReminder,serviceId,updatePaymentReminder} = this.props
      const paymentReminder = false;
      const contact = {
          accountService: accountService, alias: this.state.alias, lidFavorite: lidFavorite,paymentReminder:paymentReminder
      }
      const action = {
        alias: this.state.alias, idReminder: idReminder,serviceId:serviceId
      }
          executeTaggeo({
              action: "Click Guardar",
              step: "Formulario de referencia",
              service: this.props.tagServiceId,
          })
  if(idReminder === undefined){
      addFavoritesRef(contact,tagServiceId); 
      this.setState({ modal: true }) 
  }else{
    updatePaymentReminder(action); 
    this.setState({ modal: true }) 
  }
  }

    handleInputChange = (event) => {
        let newValue = event.target.value.substr(0, 30);
        newValue = newValue.replace(/\p{Extended_Pictographic}/u, "");
        this.setState({ alias: newValue })
        if (event.target.value === '' || event.target.value === this.props.alias) {
            this.setState({ disabledButton: true });
        } else {
            this.setState({ disabledButton: false });
        }
        
       
    }

    handleEditCloseModal = () => {
        const {executeTaggeo,tagServiceId,closeModalFavoriteServices} = this.props;
        if(this.state.codigo === "CP0521"){
            executeTaggeo({
              action: "Click alert Entendido",
              step: "Formulario de pago",
              alert_id: "Guardado editado sin éxito",
              service: tagServiceId,
            });
          }else if(this.state.codigo === "CP0522"){
            executeTaggeo({
              action: "Click Entendido",
              step: "Formulario de pago",
              confirmation_id: "Guardado editado con éxito",
              service: tagServiceId,
            });
          }
        this.setState({ modal: false })
        closeModalFavoriteServices()
    }

    openSnackBar = () => {  // Abre snackbar de confirmación de eliminación de servicio guardado
        this.props.executeTaggeo({
            action: "View snackbar Servicio eliminado",
            step: "Formulario de pago",
            service: this.props.tagServiceId,
          });
        const parameters = `{"show": true,"name": "snackbarConfirmDeleteFav","cp": "CP0527","flow": "PagoServicios"}`;
            const url = '{"app": "startEventNoClose","to": "showGenericSnackBack", "parameters": ' + JSON.stringify(parameters) +	"}";    
            sdkclaro.getInstance().openNative(url);
      }

    openDeleteFavoriteService = (lidFavorite) => { // Abre modal de confirmación de eliminación de servicio guardado
        const {executeTaggeo, tagServiceId} = this.props;
    
        this.setState({
        cpMessage: "CP0524",
        isOpenListFavs: false ,
        isDeletedFavorite: true ,
        idFavServiceCurrent: lidFavorite
        });
        executeTaggeo({
          action: "View alert",
          step: "Formulario de pago",
          alert_id: "Seguro de eliminar servicio guardado",
          service: tagServiceId,
        });
      }
    
      closeDeleteFavoriteService = () => {  // Cierra modal de confirmación de eliminación de servicio guardado
        const {executeTaggeo, tagServiceId} = this.props;
    
        this.setState({ isDeletedFavorite: false });
        this.setState({ isOpenListFavs: true }); 
        executeTaggeo({
          action: "Click alert Cancelar",
          step: "Formulario de pago",
          alert_id: "Seguro de eliminar servicio guardado",
          service: tagServiceId,
        });
      }
    
      deleteFavoriteService = () => {  // Elimina servicio guardado
        const {executeTaggeo, tagServiceId, deletePaymentReminder,idReminder} = this.props;
    
        executeTaggeo({
          action: "Click alert Eliminar",
          step: "Formulario de pago",
          alert_id: "Seguro de eliminar servicio guardado",
          service: tagServiceId,
        });
    
        deletePaymentReminder(idReminder);
    
        this.setState({ isDeletedFavorite: false });
    
        setTimeout(() => {
          this.deleteComplete();
        }, 800);
    
      }
      
      deleteComplete = () => {
        const {handleSetFavValue,closeModalFavoriteServices,deletePaymentReminderError,tagServiceId} = this.props;
    
        if(deletePaymentReminderError === undefined){
          handleSetFavValue('');
          this.openSnackBar();
          closeModalFavoriteServices(true);
        }
      }

      handleClickDeleteCloseModal = () => { //
        const {executeTaggeo, tagServiceId, closeModalFavoriteServices,handleSetFavValue} = this.props;
        const {cpMessage} = this.state;
        if(cpMessage === "CP0525"){
          executeTaggeo({
            action: "Click alert Entendido",
            step: "Formulario de pago",
            alert_id: "Imposible eliminar servicio",
            service: tagServiceId,
          });
        }
        handleSetFavValue('');
        this.setState({isFavoriteServices: false})
        closeModalFavoriteServices(true);
      }

    render() {
        const { closeModalFavoriteServices,isLoadingGetFavServices, isFavoriteServices, isContainerTelcel, mediaService,lidFavorite,hasFavsError,deletePaymentReminderError,executeTaggeo,tagServiceId,listMessagesFavServices,accountService,logoService,idReminder,canPaymentReminder,isLoadingReminderReducerServices,expirationDate } = this.props;
        const {modal,alias,disabledButton,messageInformation,codigo,cpMessage,isDeletedFavorite} = this.state
        const textReference = mediaService.find(ele => ele.id === 'buttonBox').cp.find(ele => ele.id === 'favoritos').textRef;

        let messageInformationDelete = { data: {} };
        if (listMessagesFavServices.length !== 0) {
            messageInformationDelete = getMessage(listMessagesFavServices, cpMessage);
        }

        if (canPaymentReminder && isLoadingReminderReducerServices) {
            return (
              <ModalCustomContainer isOpen={isLoadingReminderReducerServices}>
              <ModalCardLoader isOpen={isLoadingReminderReducerServices} />
              </ModalCustomContainer>
            );
          } else if (isLoadingGetFavServices) {
            return (
              <ModalCustomContainer isOpen={isLoadingGetFavServices}>
              <ModalCardLoader isOpen={isLoadingGetFavServices} />
              </ModalCustomContainer>
            );
        } else {
            return (
                <>
                    {!modal && (
                        <ModalCustomContainer isOpen={isFavoriteServices} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                            <ClaroCardSimple
                                backgroundColor='#ffffff'
                                borderRadius={lidFavorite ? '8px' : '20px 20px 0px 0px'}
                                margin={lidFavorite ? '0px 16px ' : '0 0 -70% 0'}
                                height={lidFavorite ? 'auto' : '100%'}
                                width={lidFavorite ? 'auto' : '100%'}
                                fadeIn={lidFavorite ? '' : 'fadeIn'}
                                fadeInTime={lidFavorite ? '' : '1s'}
                                cubicBezier={lidFavorite ? '' : 'cubic-bezier(0.9, 0, 0.9, 1)'}
                                padding='20px 16px 32px 16px'
                                addCloseEfect={false}
                            >
                                <ContainerListFavs>
                                    <ButtonClose 
                                    onClick={()=>{
                                        closeModalFavoriteServices();
                                    }}
                                    >
                                        <img
                                            src={isContainerTelcel ? "/images/icono_salir_contenedor.png" : "/images/icono_salir.svg"}
                                            width={isContainerTelcel ? "24" : "16"}
                                            height={isContainerTelcel ? "24" : "16"}
                                        />
                                    </ButtonClose>
                                    {tagServiceId !== 'amigopaguitos' &&(
                                        <ClaroImage {...logoService}/>
                                    )
                                        }
                                    
                                    {tagServiceId === 'amigopaguitos' &&(<LogoServiceFavs
                                        src={this.props.configImgService}
                                        width="45%"
                                        height="auto"
                                        alt=""
                                    /> )}
                                    <SubtitleServiceFavs>Guardar Servicio</SubtitleServiceFavs>
                                    <div style={containerAliasStyles}>
                                    <InputTitleClaroSocio
                                        text="Alias:"
                                        titleStyle={{
                                            background: "transparent"
                                        }}
                                    />
                                    <ClaroInputField
                                        onChange={this.handleInputChange}
                                        placeholder="Ingresa un alias para tu servicio"
                                        value={alias}
                                        width="100%"
                                        maxLength="30"
                                        />
                                    </div>
                                    <div style={{ padding: expirationDate ? '5px 16px': '16px', width:'100%', marginBottom: '16px'}}>
                                    <InputTitleClaroSocio
                                        text={textReference}
                                        titleStyle={{
                                            background: "transparent",
                                            color: "rgb(70, 80, 90)",
                                        }}
                                    />

                                    <p style={{ color: '#474747', fontSize: '14px', width: '100%', marginTop: "4px" }}>{accountService}</p>
                                    </div>
                                    {/* {expirationDate &&(
                                    <div style={containerExpirationStyles}>
                                    
                                    <InputTitleClaroSocio
                                        text='Próxima fecha de pago:'
                                        titleStyle={{
                                            background: "transparent",
                                            color: "rgb(70, 80, 90)",
                                        }}
                                    />

                                    <p style={{ color: '#474747', fontSize: '14px', width: '100%', marginTop: "4px" }}>{expirationDate}</p>
                                    
                                    </div>
                                    )} */}
                                    <ClaroButton
                                        disabled={disabledButton}
                                        favoritos={true}
                                        backgroundColor='#000'
                                        activeBackgroundButton='none'
                                        hoverBackgroundButton='none'
                                        color='#fff'
                                        fontFamily='Amx-Bold'
                                        fontWeight='700'
                                        fontSize='4.05vw !important'
                                        lineHeight="normal!important"
                                        borderRadius='50px'
                                        width='61.111vw'
                                        height='11.4667vw'
                                        margin='0 auto'
                                        display='block'
                                        onClick={()=>{
                                            this.saveFavorites();
                                        }}
                                    >
                                        Guardar
                                    </ClaroButton>
                                    {idReminder && 
                                    <p style={{ color: '#474747', fontSize: '14px', width: 'auto', marginTop: '15px', fontWeight: 'bold', textAlign:'center', borderBottom: '1px solid #474747' }}  onClick={()=>{
                                        this.openDeleteFavoriteService();
                                    }}>Eliminar servicio</p>
                                    }
                                </ContainerListFavs>
                            </ClaroCardSimple>
                        </ModalCustomContainer>
                    )}
                    <>
                        {modal && codigo !== '' && (

                            <div style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                {!lidFavorite && !idReminder && (
                                    <>
                                    {!hasFavsError && (
                                    <ToolTipTelcelAvisos
                                        tooltipInformation={getMessage(listMessagesFavServices, codigo)}
                                        isOpen={modal}
                                        background={true}
                                        color={"white"}
                                        handleNextAction={
                                            () => {
                                                executeTaggeo({
                                                    action: "Click confirmation Entendido",
                                                    step: "Formulario de pago",
                                                    confirmation_id: "Servicio Guardado",
                                                    service: tagServiceId,
                                                })
                                                this.setState({ modal: false })
                                                closeModalFavoriteServices()
                                            }
                                        }
                                    />
                                    )}
                                    {hasFavsError && (
                                      <ModalCustomContainer isOpen={modal} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                                    <ModalCardOk
                                        isOpen={modal}
                                        srcImage={messageInformation.data.icon}
                                        text={messageInformation.data.subject}
                                        textdetail={messageInformation.data.message}
                                        buttontext={messageInformation.data.buttons}
                                        onclickModal={() => {
                                            executeTaggeo({
                                                action: "Click alert Entendido",
                                                step: "Formulario de pago",
                                                alert_id: "Imposible consultar guardados",
                                                service: tagServiceId,
                                            })
                                            this.setState({ modal: false })
                                            closeModalFavoriteServices()
                                        }}
                                        fontSizeTitle={validateUserAgent() === 'android' ? '22px' : '18px'}
                                        fontFamilyTitle={"Amx-Bold"}
                                        fontSizeDetail={validateUserAgent() === 'android' ? '18px' : '14px'}
                                        fontSizeButton={validateUserAgent() === 'android' ? '16px' : '14px'}
                                    />
                                    </ModalCustomContainer>
                                    )}
                                    </>
                                )}
                                {(lidFavorite || idReminder)  && (
                                  <ModalCustomContainer isOpen={modal} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                                    <ModalCardOk
                                        isOpen={modal}
                                        srcImage={messageInformation.data.icon}
                                        text={messageInformation.data.subject}
                                        textdetail={messageInformation.data.message}
                                        buttontext={messageInformation.data.buttons}
                                        onclickModal={() => {
                                            this.handleEditCloseModal()
                                        }}
                                        fontSizeTitle={validateUserAgent() === 'android' ? '22px' : '18px'}
                                        fontFamilyTitle={"Amx-Bold"}
                                        fontSizeDetail={validateUserAgent() === 'android' ? '18px' : '14px'}
                                        fontSizeButton={validateUserAgent() === 'android' ? '16px' : '14px'}
                                    />
                                    </ModalCustomContainer>
                                )}
                            </div>

                        )}
                    </>


                    <>
                    {isDeletedFavorite && (
                <ModalCustomContainer isOpen={isDeletedFavorite} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
                  <ClaroCardSimple
                    css
                    backgroundColor='#ffffff'
                    borderRadius='6px'
                    margin='0px 16px'
                    padding='16px 11vw'
                    height='auto'
                    textAlign='center'
                  >
                    <section>
                      <ClaroImageBanner 
                        imageModal
                        margin='-43px 0 30px 0'
                      >
                        <img
                          width='62px' 
                          height='62px' 
                          src={messageInformationDelete.data.icon} 
                        />
                      </ClaroImageBanner>
                      <ClaroTextGeneral
                        textmodal1
                        fontFamily='Amx-Bold'
                        fontWeight='700'
                        fontSize='20px'
                        color='#000'
                        textAlign='center'
                        margin= '0px 0px 16px 0px !important'
                      >
                        {messageInformationDelete.data.subject}
                      </ClaroTextGeneral>
                      <ClaroButton
                       backgroundColor='#000'
                       activeBackgroundButton='none'
                       hoverBackgroundButton='none'
                       color='#fff'
                       fontFamily='Amx-Bold'
                       fontWeight='700'
                       fontSize='4.05vw !important'
                       lineHeight="normal!important"
                       borderRadius='50px'
                       width='61.111vw'
                       height='11.4667vw'
                       margin='0 auto !important'
                       display='block'
                        onClick={() => {
                          this.deleteFavoriteService();
                        }}
                      >
                        {messageInformationDelete.data.buttons[0]}
                      </ClaroButton>
                      <ClaroLinkButton
                        textSize= "16px"
                        textColor= "#000"
                        btnBackground= "none"
                        activeOpacity= "1"
                        textAlign= "center"
                        fontWeight="700"
                        textDecoration="underline"
                        fontFamily="Amx-Bold"
                        textTransform= "capitalize"
                        lineHeight= "24px"
                        onClick={() => {
                          this.closeDeleteFavoriteService();
                        }}
                      >
                        {messageInformationDelete.data.buttons[1]}
                      </ClaroLinkButton>
                    </section>
                  </ClaroCardSimple>
                </ModalCustomContainer>
              )}  
          {deletePaymentReminderError && (
            <ModalCustomContainer isOpen={isFavoriteServices} backgroundColor={'rgba(0, 0, 0, 0.65)'}>
            <ClaroModalCardOk 
              isOpen={isFavoriteServices} 
              heightImg='62px'
              widthImg='62px'
              srcImage={messageInformationDelete.data.icon ? messageInformationDelete.data.icon : ""}
              backgroundColor="rgba(0,0,0,0.65)"
              paddingCard="16px 11vw;"
              borderRadiusCard='5px'
              text={messageInformationDelete.data.subject ? messageInformationDelete.data.subject : ""}
              fontFamilyTitle='Amx-Bold'
              fontSizeTitle='20px'
              textdetail={messageInformationDelete.data.message ? messageInformationDelete.data.message : ""}
              fontSizeDetail='16px'
              fontFamilyDetail='Amx-Regular'
              buttontext={messageInformationDelete.data.buttons ? messageInformationDelete.data.buttons[0] : ""}
              colorButton='#fff'
              backgroundColorButton='#000'
              activeBackgroundButton='none'
              hoverBackgroundButton='none'
              fontSizeButton='4.05vw !important'
              onClickImg=""
              textAlignLinkButton="center"
              textDecorationLinkButton="underline"
              fontWeightLinkButton="bold"
              fontFamilyLinkButton ="Amx-Regular"
              onclickModal={() => this.handleClickDeleteCloseModal()}
            /> 
            </ModalCustomContainer>
          )}
                    
                    </>

                </>
            )
        }
    }
}

function mapStateToProps(state) {
    const { payments, favoritesRefReducer,payReminderReducer } = state;
    const { messages } = payments;
    const listFavServices = getListFavsServices(favoritesRefReducer);
    const listMessagesFavServices = getMessageFavServices(favoritesRefReducer);
    return {
        favoriteServices: state,
        canPaymentReminder: payments.canPaymentReminder,
        updatePaymentReminderSucces: state.payReminderReducer.updatePaymentReminderSucces,
        updatePaymentReminderError: state.payReminderReducer.updatePaymentReminderError,
        deletePaymentReminderSucces: state.payReminderReducer.deletePaymentReminderSucces,
        deletePaymentReminderError: state.payReminderReducer.deletePaymentReminderError,
        getPaymentReminderSucces: state.payReminderReducer.getPaymentReminderSucces,
        getPaymentReminderError: state.payReminderReducer.getPaymentReminderError,
        hasFavSucces:state.favoritesRefReducer.ResponseSuccess,
        hasFavsError: state.favoritesRefReducer.ResponseError,
        errorCodeFavs: state.favoritesRefReducer.CodeError,
        isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
        isLoadingReminderReducerServices: state.payReminderReducer.isLoading,
        listFavServices,
        messages: messages,
        listMessagesFavServices: listMessagesFavServices,
        logoService: state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.generic.logo.data,
        mediaService: state.payments.PAYMENT_SERVICE_CONF.services[0].serviceData.generic.elements,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            addFavoritesRef,
            getMessagesFavoritesServices,
            updatePaymentReminder,
            deletePaymentReminder,
            getPaymentReminder,
            executeTaggeo,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateFavoriteService);

